//docType, docRef, docDecl, id, prevdocType
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Form } from 'semantic-ui-react'
import { AddBtn } from '../../../../commonComponents/AddBtn'
import { FormTitle } from '../../../../commonComponents/FormTitle'
import List from '../../../../commonComponents/List'
import { CustomLoader } from '../../../../commonComponents/formComponents/loader'
import PreviousDocumentsDetails from './previousDocumentsDetails'
import { useDocument } from '../../../hooks/useDocument'
import { getPayloadforDeleteDoc, getPayloadforAddDoc } from '../helper'
const PreviousDocuments = (props) => {
  const { isLoading, AddItem, deleteItem, updateItem, saveItem } = useDocument({
    actionType: 'CDS_HEADER',
    tableName: 'declarationPreviousDoc',
    containerKey: 'header',
  })

  const addItemPayload = getPayloadforAddDoc(
    'declarationPreviousDoc',
    'IM_HEADER_PREVIOUS_DOCUMENT'
  )
  const previousDocList = useSelector((state) => state.Shipment.declarationPreviousDoc) || []

  const isFormEnabled = false
  const deletePrevDetails = useCallback(
    (id) => {
      let payload = getPayloadforDeleteDoc(id, 'declarationPreviousDoc')

      deleteItem(payload, true)
    },
    [deleteItem]
  )
  const renderItem = useCallback(
    (item) => {
      return (
        <PreviousDocumentsDetails
          key={item.id}
          item={item}
          isFormEnabled={isFormEnabled}
          updateData={updateItem}
          deleteData={deletePrevDetails}
          saveData={saveItem}
        />
      )
    },
    [isFormEnabled, updateItem, deletePrevDetails, saveItem]
  )

  return (
    <Form.Group className='float-container'>
      <FormTitle id={`header-previousDocuments`} boxNumber={'2/1'} title={'DECLARATION PREVIOUS DOCUMENT'}></FormTitle>

      <List dataSource={previousDocList} isFormEnabled={isFormEnabled} renderItem={renderItem} />

      {isLoading && <CustomLoader />}
      {previousDocList?.length < 99 && (
        <AddBtn
          disabled={(isFormEnabled || isLoading)}
          id="prevDocumentAdd"
          onClick={() => AddItem(addItemPayload, true)}
          text='Add'
        ></AddBtn>
      )}
    </Form.Group>
  )
}

export default React.memo(PreviousDocuments);